import ErrorMessage from '@BUP/components/Error/Message'
import { useGetFeatureFlagNotification } from '@BUP/hooks/Logbook/useGetFeatureFlagNotification'
import { createContext } from 'react'
import { useTranslation } from 'react-i18next'

export const FeatureFlagNotificationContext = createContext()

export const FeatureFlagNotificationContextProvider = ({ children }) => {
  const i18n = useTranslation()

  const { isLoadingFeatureFlagNotification, featureFlagNotification, errorFeatureFlagNotification } = useGetFeatureFlagNotification({})

  if (errorFeatureFlagNotification) {
    return <ErrorMessage message={i18n.t('common.resources.term.actions.read.failure', { context: 'current' })} />
  }

  return (
    <FeatureFlagNotificationContext.Provider
      value={{
        isLoadingFeatureFlagNotification,
        featureFlagNotification,
        errorFeatureFlagNotification
      }}
    >
      {children}
    </FeatureFlagNotificationContext.Provider>
  )
}
